import $ from 'jquery';
import tippy from 'tippy.js';
import View from 'mixins/view';
import MustacheComponent from '@components/mustache-component';

export const elements = {
    template: '#mustache-moderator-recommend',
    container: '.comments-modal',
    starContainer: '.f-addStarContainer',
};

export default class ModerationModal extends View {
    constructor(model) {
        super(model);
        this.instance = null;
        this.setRootEl($('<div class="moderation-modal"></div>'));
    }
    events() {
        const $container = this.getRootEl().find(elements.starContainer);
        const handleRecommendClick = (event) => {
            event.stopPropagation();
            const model = this.getModel();
            document.dispatchEvent(new CustomEvent('RecommendComment', {
                detail: {
                    id: model.get('id'),
                    isRecommended: model.get('isRecommended'),
                },
            }));
            this.destroy();
        };
        return $container.off().on('click', handleRecommendClick);
    }
    destroy() {
        if (this.instance) {
            this.instance.hide();
        }
    }
    init(target) {
        if (this.instance || !this.getRootEl().length) {
            return false;
        }
        this.render();
        const content = this.getRootEl().get(0);

        this.instance = tippy(target, {
            flip: false,
            interactive: true,
            content,
            delay: [200, 0],
            arrow: true,
            placement: 'bottom',
            arrowType: 'round',
            size: 'large',
            duration: [200, 100],
            animation: 'shift-away',
            hideOnClick: false,
        });
        return true;
    }
    render() {
        const model = this.getModel();
        const data = {
            isRecommended: model.get('isRecommended'),
        };
        const mustache = new MustacheComponent($(elements.template));
        mustache.set(data);

        const html = mustache.render();
        this.getRootEl().html(html);

        this.events();
    }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/moderation-modal.js